import React from 'react';
import { Button } from 'react-native-paper';
import { Trans } from '@lingui/macro';
import styled from 'styled-components/native';

import { padding } from '@src/configuration/constants';
import ProgressBars from '@src/screens/Journey/ProgressBars';

import Context from './Context';

type Props = {
  children?: React.ReactNode;
  onViewPostPress?: () => void;
  onPrevStoryPress?: () => void;
  onNextStoryPress?: () => void;
  duration: number;
  total: number;
  activeStory: number;
};

const Container = styled.View`
  flex: 1;
`;

const NextStory = styled.TouchableOpacity`
  flex: 1;
`;

const PauseStory = styled.TouchableOpacity`
  flex: 2;
`;

const PrevStory = styled.TouchableOpacity`
  flex: 1;
`;

const Controls = styled.View`
  position: absolute;
  top: 10%;
  width: 100%;
  height: 80%;
  flex-direction: row;
`;

const ViewPost = styled(Button).attrs(({ theme }) => ({
  color: theme.colors.onPrimary,
}))`
  margin: 0 ${padding}px ${padding}px ${padding}px;
  opacity: ${({ onPress }) => (onPress ? 1 : 0)};
`;

const Component: React.FC<Props> = ({
  activeStory,
  total,
  duration,
  children,
  onNextStoryPress,
  onPrevStoryPress,
  onViewPostPress,
}) => {
  const [paused, setPaused] = React.useState(false);
  const handlePressOut = React.useCallback(() => setPaused(false), []);
  const handlePressIn = React.useCallback(() => setPaused(true), []);

  React.useEffect(() => {
    setPaused(false);
  }, [activeStory]);

  const value = React.useMemo(() => ({ setPaused }), []);

  return (
    <Context.Provider value={value}>
      <Container>
        <ProgressBars
          paused={paused}
          active={activeStory}
          total={total}
          onNext={onNextStoryPress}
          duration={duration}
        />
        {children}
        <Controls>
          <PrevStory onPress={onPrevStoryPress} />
          <PauseStory onPressIn={handlePressIn} onPressOut={handlePressOut} />
          <NextStory onPress={onNextStoryPress} />
        </Controls>
        <ViewPost icon="chevron-left" onPress={onViewPostPress}>
          <Trans>View Post</Trans>
        </ViewPost>
      </Container>
    </Context.Provider>
  );
};

Component.displayName = 'Navigations';

export default Component;
